var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    _vm._l(_vm.summaryData, function(row, i) {
      return _c("div", { key: i, staticClass: "col-6 col-lg-3 card-wrap" }, [
        _c("div", { staticClass: "card card-total" }, [
          _c("div", { staticClass: "card-body" }, [
            row.isCurrency
              ? _c("div", { staticClass: "display-4" }, [
                  _vm._v(_vm._s(_vm._f("currency-filter")(row.blockValue)))
                ])
              : _c("div", { staticClass: "display-4" }, [
                  _c("span", [_vm._v(_vm._s(row.blockValue))]),
                  _c("span", { staticClass: "ml-1" }, [
                    _vm._v(_vm._s(_vm.unitData[i].unitLabel))
                  ])
                ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(row.blockTitle))])
          ])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c347bdbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c347bdbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/SummaryBlocks.vue
// module id = null
// module chunks = 